import PropTypes from 'prop-types';

function IFHouseholdInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11319)">
                <path
                    d="M12.9008 14.2855C13.8036 13.7797 16.3114 12.6136 16.3114 12.6136C16.4316 12.5543 16.5705 12.5453 16.6975 12.5884C16.8245 12.6315 16.9291 12.7232 16.9885 12.8435L17.49 13.8508C17.5495 13.9717 17.5587 14.1112 17.5156 14.2388C17.4725 14.3665 17.3807 14.4719 17.2601 14.5321C17.2601 14.5321 15.2163 15.648 13.8454 16.2624L12.9008 14.2855Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.99307 7.4268C4.7757 6.74822 4.76842 6.01979 4.97217 5.337C5.09437 4.80266 5.34086 4.30468 5.69162 3.88348C6.04238 3.46227 6.48753 3.12972 6.99092 2.91283C7.5652 2.62354 8.19267 2.45501 8.83461 2.41763C9.47654 2.38025 10.1193 2.47481 10.7233 2.69549C12.0733 3.29735 12.8591 4.78529 13.649 6.95033C13.7626 6.51231 13.9822 6.10897 14.2885 5.77586C14.5016 5.54306 14.782 5.38251 15.0907 5.31659C15.3993 5.25066 15.7209 5.28263 16.0105 5.40805C16.8464 5.75496 17.7492 6.66193 16.9969 8.38393C16.2446 10.1059 15.58 11.1425 15.6636 11.3096L16.3323 12.597L11.9437 14.6533L5.00143 7.44352L4.99307 7.4268Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2467 17.1738C14.2467 17.1738 13.5947 15.6316 12.7086 13.9305C11.5884 11.7529 10.7483 9.58786 10.2761 8.91495C9.7553 8.20086 9.06613 7.62655 8.26984 7.24311C7.7711 7.01669 7.22574 6.9119 6.67861 6.93733C6.13147 6.96276 5.59819 7.11769 5.1226 7.38939C4.54429 7.66981 4.03011 8.06661 3.61225 8.55494C3.1944 9.04328 2.88188 9.61263 2.69425 10.2273C2.36824 11.6609 3.0955 13.1865 4.34938 15.1049C3.93194 14.9318 3.47863 14.863 3.02862 14.9043C2.71426 14.9329 2.4167 15.059 2.17761 15.2652C1.93853 15.4713 1.7699 15.747 1.69533 16.0537C1.45709 16.9398 1.63681 18.1937 3.46748 18.6409C5.29815 19.0881 6.52695 19.1759 6.61054 19.3514C6.69413 19.527 7.23748 20.6596 7.23748 20.6596L14.2467 17.1738Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.17791 22.5778C8.17791 22.5778 11.6052 20.9435 12.9218 20.2205C13.4776 19.9153 15.1996 19.092 15.1996 19.092C15.3195 19.0311 15.4104 18.9253 15.4526 18.7978C15.4949 18.6702 15.4851 18.5311 15.4253 18.4107L14.9238 17.3992C14.8637 17.2797 14.7587 17.1889 14.6318 17.1466C14.505 17.1043 14.3665 17.114 14.2467 17.1735C14.2467 17.1735 10.7902 18.9624 9.59898 19.4807C8.65021 19.8986 7.22497 20.6593 7.22497 20.6593C7.10442 20.7195 7.01258 20.8249 6.96951 20.9525C6.92644 21.0802 6.93563 21.2197 6.99509 21.3406L7.49664 22.3479C7.5568 22.4684 7.66221 22.5603 7.78986 22.6033C7.91751 22.6464 8.05702 22.6372 8.17791 22.5778V22.5778Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.82158 12.601C8.74634 12.4129 6.68162 10.3942 6.12573 9.67529Z" fill="#F8F2ED" />
                <path
                    d="M8.82158 12.601C8.74634 12.4129 6.68162 10.3942 6.12573 9.67529"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.20301 14.0221C8.20301 14.0221 6.06724 11.5143 4.82172 10.3398Z" fill="#F8F2ED" />
                <path
                    d="M8.20301 14.0221C8.20301 14.0221 6.06724 11.5143 4.82172 10.3398"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.64184 10.2314C7.99375 11.6019 7.27098 12.9358 6.47681 14.2271Z" fill="#F8F2ED" />
                <path
                    d="M8.64184 10.2314C7.99375 11.6019 7.27098 12.9358 6.47681 14.2271"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.43812 9.4541C6.88521 10.7785 6.17516 12.0316 5.32324 13.1865Z" fill="#F8F2ED" />
                <path
                    d="M7.43812 9.4541C6.88521 10.7785 6.17516 12.0316 5.32324 13.1865"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.1464 14.4905L10.347 16.0746C10.347 16.0746 10.9405 19.5687 11.0492 21.6753C11.0994 22.6993 11.5591 25.742 11.5591 25.742C11.5591 25.742 12.4828 27.3219 15.3208 27.7023C16.8583 27.9695 18.4262 28.0159 19.9768 27.8402C21.8668 27.6637 23.7012 27.1048 25.3685 26.1976C27.1658 25.3199 27.4834 23.9531 27.6715 23.6898C27.8052 23.5101 27.7843 21.3409 27.4207 18.9418C26.9192 15.7361 26.6642 11.9326 26.6642 11.9326"
                    fill="#F8F2ED"
                />
                <path
                    d="M10.1464 14.4905L10.347 16.0746C10.347 16.0746 10.9405 19.5687 11.0492 21.6753C11.0994 22.6993 11.5591 25.742 11.5591 25.742C11.5591 25.742 12.4828 27.3219 15.3208 27.7023C16.8583 27.9695 18.4262 28.0159 19.9768 27.8402C21.8668 27.6637 23.7012 27.1048 25.3685 26.1976C27.1658 25.3199 27.4834 23.9531 27.6715 23.6898C27.8052 23.5101 27.7843 21.3409 27.4207 18.9418C26.9192 15.7361 26.6642 11.9326 26.6642 11.9326"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M26.6643 11.9325C26.7771 12.9356 25.9161 13.9512 24.4366 14.7746C22.957 15.598 20.9424 16.0661 18.6812 16.4464C17.1556 16.6775 15.6024 16.6563 14.0837 16.3837C12.1611 16.0786 10.7107 15.4099 10.1423 14.4987C10.0059 14.2871 9.92006 14.0468 9.89154 13.7966C9.75361 12.5427 11.1162 11.3682 13.2352 10.4153C14.7093 9.78512 16.2764 9.39971 17.8746 9.27424C19.2642 9.13255 20.6646 9.13255 22.0542 9.27424C24.8503 9.5083 26.5013 10.5699 26.6643 11.9325Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.8263 15.0672C24.4658 14.7997 21.0176 13.5291 17.5193 14.085C14.021 14.6409 13.3606 16.2375 13.3606 16.2375C13.3606 16.2375 16.0021 16.5844 17.0052 16.5969C19.3555 16.5257 21.6707 16.0065 23.8263 15.0672V15.0672Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.57521 15.4915L7.63123 15.7086C7.25959 15.7501 6.99195 16.085 7.03344 16.4566L7.08305 16.9011C7.12454 17.2727 7.45945 17.5403 7.83109 17.4989L9.77507 17.2818C10.1467 17.2403 10.4144 16.9054 10.3729 16.5338L10.3232 16.0893C10.2818 15.7177 9.94685 15.4501 9.57521 15.4915Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M29.4685 13.2694L27.5245 13.4864C27.1528 13.5279 26.8852 13.8628 26.9267 14.2344L26.9763 14.6789C27.0178 15.0505 27.3527 15.3182 27.7243 15.2767L29.6683 15.0597C30.04 15.0182 30.3076 14.6833 30.2661 14.3116L30.2165 13.8672C30.175 13.4955 29.8401 13.2279 29.4685 13.2694Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11319">
                    <rect width="30" height="30" fill="white" transform="translate(0.976562 0.176758)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFHouseholdInactive;

IFHouseholdInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFHouseholdInactive.defaultProps = {
    className: null,
};
